const baseCardStyles = {
  display: "flex",
  flexDir: "column",
  gap: "big",
  overflow: "hidden",
};

const baseTextWrapperStyles = {
  flexDir: "column",
  gap: "small",
  mx: "auto",
};

export const layerStyles = {
  header: {
    position: "sticky",
    zIndex: "sticky",
    top: 0,
    left: 0,
    right: 0,
    transition: "background-color .25s ease-in-out",
  },
  card: {
    inline: {
      ...baseCardStyles,
    },
    shadow: {
      light: {
        ...baseCardStyles,
        borderRadius: "biggest",
        boxShadow: "card",
        bg: "brand.background.light",
        mb: "biggest",
        p: "small",
        pb: "bigger",
      },
      dark: {
        ...baseCardStyles,
        borderRadius: "biggest",
        boxShadow: "card",
        bg: "brand.background.dark",
        p: "small",
        pb: "bigger",
      },
    },
    fill: {
      light: {
        ...baseCardStyles,
        borderRadius: { base: "big", sm: "bigger", md: "biggest" },
        bg: "brand.backgroundSecondary.light",
      },
      dark: {
        ...baseCardStyles,
        borderRadius: { base: "big", sm: "bigger", md: "biggest" },
        bg: "brand.backgroundSecondary.dark",
      },
    },
    media: {
      borderRadius: "bigger",
      overflow: "hidden",
      pos: "relative",
      w: "100%",
    },
    textWrapper: {
      inline: {
        ...baseTextWrapperStyles,
      },
      shadow: {
        ...baseTextWrapperStyles,
        px: "smaller",
      },
      fill: {
        ...baseTextWrapperStyles,
        px: "bigger",
        pb: "bigger",
      },
    },
  },
};
